module.exports = __webpack_public_path__ + "static/media/hsu.d3ca4b3e.svg";